import { stringify } from 'qs';

import { DADATA_URL } from '../../../constants/fio';
import { EPartsLower, EPartsUpper, EGender } from '../../../types/fio';

export function getRequestUrl(query: string, currentPartFIO: EPartsLower, gender: EGender, token: string) {
  const mapParts = {
    patronymic: EPartsUpper.PATRONYMIC,
    name: EPartsUpper.NAME,
    surname: EPartsUpper.SURNAME,
  };

  /**
   * Хак для parts из-за особеностей стороней апи dadata, qs делает этот параметр так:
   *   parts[0]=PATRONYMIC
   * апи так не умеет его принимать, и перестает выдавать саджест
   */
  const queryString =
    stringify({
      gender,
      token,
      query,
    }) + `&parts=${[mapParts[currentPartFIO as keyof typeof mapParts]]}`;

  return `${DADATA_URL}?${queryString}`;
}
